import { request } from './index';
import { IPOTag } from '@hylaa-npm/ipod';
export const tagUrls = {
	add: '/tag/add',
	tagList: (type: 1 | 2) => `/tag/type/${type}/list`,
	delTag: '/tag/${id}/del',
	tmpTagList: '/tag/tmp/list',
	getTagDetail: '/tag/${id}/get',
	updateName: '/tag/${id}/name/update',
	updateDesc: '/tag/${id}/desc/update',
	updateIcon: (icon: string) => `/tag/${icon}/icon/update`,
	delTmpTag: '/tag/tmp/${id}/del',
	tmpTagAdd: '/tag/tmp/add',
	getTagTmpList: (type: 1 | 2) => `/tag/tmp/type/${type}/list`,
};
/**
 * 获取标签列表
 * @param params
 */
export interface ITagsPromise {
	list: IPOTag.ITag[];
	pagination?: IPagination;
}

export const getTags = (
	type: 1 | 2,
	keyword: string,
	pagination?: IPagination,
): Promise<ITagsPromise> => {
	return new Promise((resolve) => {
		request(tagUrls.tagList(type), { body: keyword, pagination: pagination }).then((res) => {
			resolve(res as ITagsPromise);
		});
	});
};
export const getTagList = (
	type: 1 | 2,
	keyword: string,
	pagination?: IPagination,
): Promise<{
	list: ITagItem[];
	pagination: {
		take: number;
		offset: number;
		size: number;
	};
}> => {
	return new Promise((resolve) => {
		request(tagUrls.tagList(type), { body: keyword, pagination: pagination }).then((res) => {
			resolve(
				res as {
					list: ITagItem[];
					pagination: {
						take: number;
						offset: number;
						size: number;
					};
				},
			);
		});
	});
};
/**
 * 创建标签
 * @param params 创建标签参数
 * @param type 标签类型  'major' | 'team' | 1 为 专业标签 | 2 为 团队标签    默认值为 1
 * @param name 标签名称 string  必传
 * @param icon 标签图标 string | File 默认值为 ''
 * @param desc 标签描述 string 必传
 */
export const createTag = (params: {
	type?: 'major' | 'team' | 1 | 2;
	name: string;
	icon?: string | File;
	desc: string;
}): Promise<ITagItem> => {
	return new Promise((resolve, reject) => {
		const next = () => {
			request(tagUrls.add, { body: params }, 'POST')
				.then((res) => {
					resolve(res as ITagItem);
				})
				.catch((e: unknown) => {
					reject(e);
				});
		};
		if (!params.type) {
			params.type = 1;
		}
		if (params.type == 'major') {
			params.type = 1;
		}
		if (params.type == 'team') {
			params.type = 2;
		}
		if (!params.icon) {
			params.icon = '';
		}
		if (typeof params.icon != 'string') {
		} else {
			next();
		}
	});
};
/**
 * 删除指定标签
 * @param id 标签id string 必传
 */
export const delTag = (id: string): Promise<unknown> => {
	return request(tagUrls.delTag.replace('${id}', id), {}, 'GET');
};
/**
 * 获取待添加的标签列表
 * @param keyword 关键字搜索 默认值为 ""
 */
export const getTmpList = (
	keyword: string = '',
	pagination: { take: number; offset: number } = { take: 10, offset: 0 },
): Promise<{
	list: ITagItem[];
	pagination: {
		take: number;
		offset: number;
		size: number;
	};
}> => {
	return new Promise((resolve, reject) => {
		request(tagUrls.tmpTagList, { body: keyword, pagination }, 'post')
			.then((res) => {
				resolve(
					res as {
						list: ITagItem[];
						pagination: {
							take: number;
							offset: number;
							size: number;
						};
					},
				);
			})
			.catch((e) => {
				reject(e);
			});
	});
};
/**
 * 获取单个标签详情
 * @param id 单个标签的id string
 */
export const getTagDetail = (id: string): Promise<ITagItem> => {
	return new Promise((resolve, reject) => {
		request(tagUrls.getTagDetail.replace('${id}', id), {}, 'get')
			.then((res) => {
				resolve(res as ITagItem);
			})
			.catch((e) => {
				reject(e);
			});
	});
};
/**
 * 修改单个标签的标签名称
 * @param id 标签id string 必传
 * @param name 标签名称 string 必传
 */
export const updateName = (id: string, name: string): Promise<unknown> => {
	return request(tagUrls.updateName.replace('${id}', id), { body: name.trim() }, 'post');
};
export const updateIcon = (id: string, icon: string): Promise<unknown> => {
	return request(tagUrls.updateIcon(id), { body: icon });
};
/**
 * 修改单个标签的描述信息
 * @param id 标签id string 必传
 * @param desc 描述信息 string 必传
 */
export const updateDesc = (id: string, desc: string): Promise<unknown> => {
	return request(tagUrls.updateDesc.replace('${id}', id), { body: desc.trim() }, 'post');
};
/**
 * 删除指定的临时标签
 * @param id
 */
export const delTmpTag = (id: string): Promise<unknown> => {
	return request(tagUrls.delTmpTag.replace('${id}', id), {}, 'get');
};
/** 添加临时标签 */
export const tmpTagAdd = (params: {
	projectId: string;
	name: string;
	type: '1' | '2';
	icon: string;
	desc: string;
}): Promise<unknown> => {
	return request(tagUrls.tmpTagAdd, { body: params });
};

export const addTag = (params: {
	name: string;
	type: 1 | 2;
	icon: string;
	desc: string;
}): Promise<unknown> => {
	return request(tagUrls.add, { body: params });
};

export const getTagTmpList = (
	type: 1 | 2,
	keyword: string,
	pagination: { take: number; offset: number } = { take: 10, offset: 0 },
): Promise<unknown> => {
	return request(tagUrls.getTagTmpList(type), { body: keyword, pagination: pagination });
};
